var _variants, _variants2;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _styled from '@emotion/styled/base';
import { css } from '@emotion/react';
import { Button } from '@tablekit/button';
import { Icon } from '@tablekit/icon';
import { Spacing } from '@tablekit/theme';
import { Typography } from '@tablekit/typography';
import { getThemeValue, variant, margin } from '@tablekit/utils';
import { alertThemeNamespace, alertClassicTheme } from './themes.js';
import { Appearance } from './utils.js';

var AlertContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1223ckj7"
} : {
  target: "e1223ckj7",
  label: "AlertContainer"
})("display:flex;flex-direction:column;width:fit-content;min-width:200px;max-width:600px;min-height:44px;", Typography.Body2, ";color:", getThemeValue("".concat(alertThemeNamespace, ".textColor"), alertClassicTheme.textColor), ";background-color:", getThemeValue("".concat(alertThemeNamespace, ".backgroundColor"), alertClassicTheme.backgroundColor), ";box-shadow:1px 1px 0 1px ", getThemeValue("".concat(alertThemeNamespace, ".boxShadowColor"), alertClassicTheme.boxShadowColor), ";padding:6px ", Spacing.L1, " 6px ", Spacing.L3, ";", function (_ref) {
  var isDismissible = _ref.isDismissible;
  return !isDismissible && "padding-right: ".concat(Spacing.L3, ";");
}, " border-radius:3px;", variant({
  prop: 'appearance',
  default: Appearance.Primary,
  variants: (_variants = {}, _defineProperty(_variants, Appearance.Primary, function (props) {
    return /*#__PURE__*/css("border-left:", Spacing.L1, " solid ", getThemeValue("".concat(alertThemeNamespace, ".primary.borderColor"), alertClassicTheme.primary.borderColor)(props), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:AlertContainer;"));
  }), _defineProperty(_variants, Appearance.Success, function (props) {
    return /*#__PURE__*/css("border-left:", Spacing.L1, " solid ", getThemeValue("".concat(alertThemeNamespace, ".success.borderColor"), alertClassicTheme.success.borderColor)(props), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:AlertContainer;"));
  }), _defineProperty(_variants, Appearance.Danger, function (props) {
    return /*#__PURE__*/css("border-left:", Spacing.L1, " solid ", getThemeValue("".concat(alertThemeNamespace, ".danger.borderColor"), alertClassicTheme.danger.borderColor)(props), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:AlertContainer;"));
  }), _defineProperty(_variants, Appearance.Warning, function (props) {
    return /*#__PURE__*/css("border-left:", Spacing.L1, " solid ", getThemeValue("".concat(alertThemeNamespace, ".warning.borderColor"), alertClassicTheme.warning.borderColor)(props), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:AlertContainer;"));
  }), _variants)
}), ";");

var AlertContentContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1223ckj6"
} : {
  target: "e1223ckj6",
  label: "AlertContentContainer"
})("position:relative;display:flex;", function (_ref2) {
  var shouldHideIcon = _ref2.shouldHideIcon;
  return !shouldHideIcon && 'padding-top: 5px;';
}, ";");

var AlertMark = /*#__PURE__*/_styled(Icon, process.env.NODE_ENV === "production" ? {
  target: "e1223ckj5"
} : {
  target: "e1223ckj5",
  label: "AlertMark"
})("margin-top:1px;", variant({
  prop: 'appearance',
  default: Appearance.Primary,
  variants: (_variants2 = {}, _defineProperty(_variants2, Appearance.Primary, function (props) {
    return /*#__PURE__*/css("color:", getThemeValue("".concat(alertThemeNamespace, ".primary.iconColor"), alertClassicTheme.primary.iconColor)(props), ";fill:", getThemeValue("".concat(alertThemeNamespace, ".primary.fillColor"), alertClassicTheme.primary.fillColor)(props), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:AlertMark;"));
  }), _defineProperty(_variants2, Appearance.Success, function (props) {
    return /*#__PURE__*/css("color:", getThemeValue("".concat(alertThemeNamespace, ".success.iconColor"), alertClassicTheme.success.iconColor)(props), ";fill:", getThemeValue("".concat(alertThemeNamespace, ".success.fillColor"), alertClassicTheme.success.fillColor)(props), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:AlertMark;"));
  }), _defineProperty(_variants2, Appearance.Danger, function (props) {
    return /*#__PURE__*/css("color:", getThemeValue("".concat(alertThemeNamespace, ".danger.iconColor"), alertClassicTheme.danger.iconColor)(props), ";fill:", getThemeValue("".concat(alertThemeNamespace, ".danger.fillColor"), alertClassicTheme.danger.fillColor)(props), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:AlertMark;"));
  }), _defineProperty(_variants2, Appearance.Warning, function (props) {
    return /*#__PURE__*/css("color:", getThemeValue("".concat(alertThemeNamespace, ".warning.iconColor"), alertClassicTheme.warning.iconColor)(props), ";fill:", getThemeValue("".concat(alertThemeNamespace, ".warning.fillColor"), alertClassicTheme.warning.fillColor)(props), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:AlertMark;"));
  }), _variants2)
}), ";");

var AlertContent = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1223ckj4"
} : {
  target: "e1223ckj4",
  label: "AlertContent"
})(function (props) {
  var shouldHideIcon = props.shouldHideIcon,
      isDismissible = props.isDismissible;
  var horizontalMargin = shouldHideIcon ? 0 : Spacing.L2;
  var options = {
    top: 0,
    bottom: 0,
    left: horizontalMargin,
    right: isDismissible ? 40 : horizontalMargin
  };
  return margin(options)(props);
}, ";");

var AlertCloseButton = /*#__PURE__*/_styled(Button, process.env.NODE_ENV === "production" ? {
  target: "e1223ckj3"
} : {
  target: "e1223ckj3",
  label: "AlertCloseButton"
})("position:absolute;top:0;right:0;align-items:center;justify-content:center;color:", getThemeValue("".concat(alertThemeNamespace, ".closeButton.color"), alertClassicTheme.closeButton.color), ";");

var AlertFooterButton = /*#__PURE__*/_styled(Button, process.env.NODE_ENV === "production" ? {
  target: "e1223ckj2"
} : {
  target: "e1223ckj2",
  label: "AlertFooterButton"
})("color:", getThemeValue("".concat(alertThemeNamespace, ".actionBtnColor"), alertClassicTheme.actionBtnColor), ";");

var AlertFooterContainer = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1223ckj1"
} : {
  target: "e1223ckj1",
  label: "AlertFooterContainer"
})("margin-top:", Spacing.L1, ";display:flex;justify-content:flex-end;align-items:center;&>*:not(:last-child){", margin({
  right: Spacing.L2
}), ";}");

var AlertWrapper = _styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1223ckj0"
} : {
  target: "e1223ckj0",
  label: "AlertWrapper"
})("margin-top:", Spacing.L2, ";&:nth-of-type(1){margin-top:0;}");

export { AlertCloseButton, AlertContainer, AlertContent, AlertContentContainer, AlertFooterButton, AlertFooterContainer, AlertMark, AlertWrapper };
